<div class="content-wrapper">
  <div class="col statistic">
    <div class="title">Statistics</div>
    <div class="statistic-wrapper" *ngIf="!loadingStats; else spinner">
      <div class="stat-row" *ngFor="let stat of stats">
        <label class="item-name">{{ stat.description }}</label>
        <label class="item-value">{{ stat.value }}</label>
      </div>
    </div>
    <form [formGroup]="timezoneForm">
      <div class="timezone-block">
        <label class="timezone-title">Timezone</label>

        <mat-select class="timezone-select" formControlName="timezone">
          <mat-option *ngFor="let timezoneItem of timezoneCatalog" [value]="timezoneItem">
            {{timezoneItem}}
          </mat-option>
        </mat-select>
        <button class="btn" [disabled]="unavalableToSave || timezoneForm.untouched" (click)="saveTimezone()">Save</button>
      </div>
      <div class="timezone-pending" *ngIf="timezonePendingOn">
        Pending &mdash; device still reports {{ timezonePendingOn }}
      </div>
    </form>

  </div>
  <div class="col services">
    <div class="title">Services</div>
    <div class="service-wrapper" *ngIf="!loadingServiceStats; else spinner">
      <div class="service-row header">
        <label class="service-name">Service</label>
        <label class="service-created" *ngIf="showCreatedColumn">Created</label>
        <label class="service-status">Status</label>
        <label class="service-cpu">CPU</label>
        <label class="service-mem" *ngIf="showMemColumn">RAM</label>
      </div>
      <div class="service-row" *ngFor="let service of services">
        <label class="service-name">{{ service.name }}</label>
        <label class="service-created" *ngIf="showCreatedColumn">{{ service.created || '' }}</label>
        <label class="service-status">{{ service.status || ''}}</label>
        <label class="service-cpu">{{ service.cpu || ''}}</label>
        <label class="service-mem" *ngIf="showMemColumn">{{ service.mem || '' }}</label>
        <button class="btn small" (click)="restart(service.name)">Restart</button>
      </div>
    </div>

    <div class="zone-engines" *ngIf="zoneAudioEngines.length">
      <div class="subtitle">Zone Audio Engine</div>
      <div class="zone-engine-row" *ngFor="let engine of zoneAudioEngines">
        <label class="zone-name">{{ engine.zoneName }}</label>
        <span class="engine-chip" [class.rust]="engine.isRust">{{ engine.implLabel }}</span>
        <span class="engine-source" *ngIf="!engine.reportedByDevice"
              title="The device has not reported a running zone audio service; showing the configured setting.">
          configured
        </span>
      </div>
    </div>

    <div class="restart-groups">
      <div class="subtitle">Restart Groups</div>
      <div class="restart-group-row">
        <div class="restart-group-text">
          <label class="restart-group-name">Restart services (audio-safe)</label>
          <span class="restart-group-desc">All services except the hot audio path and database. Should not interrupt audio playback.</span>
        </div>
        <button class="btn small" (click)="restartSafeServices()">Restart</button>
      </div>
      <div class="restart-group-row">
        <div class="restart-group-text">
          <label class="restart-group-name">Restart all services (incl. audio)</label>
          <span class="restart-group-desc">All services including those delivering audio. Will briefly interrupt audio playback.</span>
        </div>
        <button class="btn small warn" (click)="restartAllServices()">Restart</button>
      </div>
      <div class="restart-group-row">
        <div class="restart-group-text">
          <label class="restart-group-name">Restart state database (MongoDB)</label>
          <span class="restart-group-desc">Local state database only. Will interrupt audio playback while services reconnect.</span>
        </div>
        <button class="btn small warn" (click)="restartDatabase()">Restart</button>
      </div>
    </div>
  </div>
</div>
<div class="action-buttons">
  <button class="btn" (click)="reboot()">Reboot Player</button>
  <button class="btn" [disabled]="!isUpdateAvailable" (click)="update()">Update</button>
</div>

<ng-template #spinner>
  <div class="spinner-wrapper">
    <mat-spinner [diameter]="50"></mat-spinner>
  </div>
</ng-template>
